import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import Login from './components/Login.js';  // Import your login component here
import{ getAuth, onAuthStateChanged } from "firebase/auth";
import Mart from './components/Mart.js';
import PrivateRoute from './PrivateRoute.js';
// import auth from "./config/firebase.jsx"; 
//import { getDatabase, ref, onValue } from "firebase/database";


function App() {

  const auth = getAuth();


  /*const [data, setData] = useState([]);

  useEffect(() => {
    const database = getDatabase(cong);
    const collectionRef = ref(database, 'collection');
    const fetchData = () => {
      onValue(collectionRef, (snapshot) => {
        const dataItem = snapshot.val();
        if (dataItem) {
          const displayItem = Object.values(dataItem);
          setData(displayItem);
        }
      });
    };
    fetchData();
  }, []);*/

  /*return (
    <Router>
      <Routes>
        <Route path="/login" component={Login} />
        <PrivateRoute path="/mart" component={Mart} />
      </Routes>
    </Router>
  );

  if (user) {
    return (
      <div className="App">
      <Mart />
    </div>
    )
  } else {
    return (
      <div className="App">
        <Login />
      </div>
    );
  }*/
 


  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path="/mart" element={<Mart />} />
          <Route exact path="/" element={<Login/>} />
        </Routes>
      </Router>
    </div>
  );

}

export default App;
